module.exports = __webpack_public_path__ + "img/544d50c.jpg";